import Banner from '../media/img/banner2.png'
import '../index.css'
function Inicio() {
    return (
        <div >
            <div className="row">
                <div className="container pl-0 pr-0">
                    <div className="wraperBnnerStartOrder">

                        <div className="container-fluid bannerP" id="" style={{ height: "480px", backgroundImage: `url(${Banner})` }}>
                            <h1 style={{ color: "white" }}>Empiece a ordenar</h1> 
                            <div className="row justify-content-center">
                                {/* <div className="col-sm-12 col-md-7 col-lg-5 col-xl-5 col-12">
                                    <ul className="nav nav-tabs align-items-end" id="myTab" role="tablist">
                                        <li className="nav-item">
                                            <a className="nav-link acarryout" id="profile-tab" onclick="locationTabGTMCall();" data-toggle="tab" href="#pickup" role="tab" aria-controls="profile" aria-selected="false">RECOJO EN TIENDA</a>
                                        </li>
                                    </ul>


                                    <div className="tab-content" id="myTabContent">
                                        <div className="tab-pane fade show active adelivery" id="delivery" role="tabpanel" aria-labelledby="delivery-tab" onclick="changeOrderMode('Delivery')">

                                            <p className="txtOr">o</p>
                                            <div className="wraperSearchBox">
                                                <input className="txtSearchBox txtSearchLocation" placeholder="Ingrese su dirección" type="text" value="" />

                                                <button className="btn btn-outline-secondary btnsearchClose" type="button" id="btnClearAddress">
                                                    <img src="/Content/OnlineOrderingImages/Location/closeIcon.png" alt=" Peru Close Icon" />
                                                </button>

                                                <span className="field-validation-valid text-danger help-block" ></span>
                                            </div>

                                        </div>



                                        <div className="tab-pane fade acarryout" id="pickup" role="tabpanel" aria-labelledby="pickup-tab" onclick="changeOrderMode('Carryout')">

                                            <a onclick="showLocationDialogContent();">Usar mi ubicaci&#243;n actual </a>
                                            <p className="txtOr">o</p>
                                            <div className="wraperSearchBox">
                                                <input className="txtSearchBox txtSearchLocation" id="RestaurantSearchKeywordCarryout" name="RestaurantSearchKeywordCarryout" placeholder="Ingrese su dirección" type="text" value="" />
                                                <button className="btn btn-outline-secondary btnsearchClose" type="button" id="btnClearAddress">
                                                    <img src="/Content/OnlineOrderingImages/Location/closeIcon.png" alt=" Peru Close Icon" />
                                                </button>
                                                <span className="field-validation-valid text-danger help-block"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    )
}
export default Inicio;